import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import useAppStore from '@views/app.store';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import AuthDialog from '@/components/authDialog.vue';
import GEOLoading from '@components/GEOLoading.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    const appStore = useAppStore();
    const route = useRoute(); // 获取当前路由对象
    const router = useRouter(); // 新增 router 实例
    onMounted(() => {
      // 使用路由守卫确保获取到最终路由
      router.isReady().then(() => {
        if (!route.meta?.skipAuth) {
          appStore.init();
        } else {
          appStore.loading = false;
        }
      });
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_config_provider = _resolveComponent("el-config-provider");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_config_provider, {
        locale: _unref(zhCn)
      }, {
        default: _withCtx(() => [_createVNode(_Transition, {
          name: "fade"
        }, {
          default: _withCtx(() => [_unref(appStore).loading ? (_openBlock(), _createBlock(GEOLoading, {
            key: 0
          })) : _createCommentVNode("", true)]),
          _: 1
        }), !_unref(appStore).loading ? (_openBlock(), _createBlock(_component_router_view, {
          key: 0
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["locale"]), _createVNode(AuthDialog)], 64);
    };
  }
});